'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _actions = require('./actions');
var _actions2 = _interopRequireDefault(_actions);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var BrowserReplay = function () {
  function BrowserReplay() {
    _classCallCheck(this, BrowserReplay);
  }
  _createClass(BrowserReplay, null, [{
    key: 'playEvents',
    value: function playEvents() {
      if (!localStorage.recordedAction) console.error('no saved actions found');
      var action = _actions2.default.fromJSON(document, JSON.parse(localStorage.recordedAction));
      console.log('play action', action);
      action.play().then(function () {
        return console.log('done');
      }, console.error);
    }
  }]);
  return BrowserReplay;
}();
BrowserReplay.displayName = 'BrowserReplay';
exports.default = BrowserReplay;